import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/img/logo_leanpath.png'


const _hoisted_1 = { class: "centered-container" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "form" }
const _hoisted_4 = { class: "actions md-layout md-alignment-center-space-between" }
const _hoisted_5 = {
  key: 0,
  class: "loading-overlay"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_notifications = _resolveComponent("notifications")!
  const _component_md_input = _resolveComponent("md-input")!
  const _component_md_field = _resolveComponent("md-field")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_md_snackbar = _resolveComponent("md-snackbar")!
  const _component_md_progress_spinner = _resolveComponent("md-progress-spinner")!
  const _component_md_content = _resolveComponent("md-content")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_notifications),
    _createVNode(_component_md_content, { class: "md-elevation-3" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _cache[3] || (_cache[3] = _createElementVNode("img", { src: _imports_0 }, null, -1)),
          _createElementVNode("div", null, _toDisplayString(_ctx.$t('ご登録のメールアドレスをご入力ください')), 1),
          _createElementVNode("div", null, _toDisplayString(_ctx.$t('パスワード再発行のご案内をメールアドレスまでお送りします')), 1)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_md_field, null, {
            default: _withCtx(() => [
              _createElementVNode("label", null, _toDisplayString(_ctx.$t('メールアドレス')), 1),
              _createVNode(_component_md_input, {
                modelValue: _ctx.state.email,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.email) = $event)),
                autofocus: ""
              }, null, 8, ["modelValue"])
            ], undefined, true),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_router_link, { to: "/login" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('ログイン画面へ')), 1)
            ], undefined, true),
            _: 1
          }),
          _createElementVNode("button", {
            class: "",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.send && _ctx.send(...args)))
          }, _toDisplayString(_ctx.$t('メール送信')), 1)
        ]),
        _createVNode(_component_md_snackbar, {
          "md-active": _ctx.state.showSnackbar,
          "onUpdate:mdActive": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.showSnackbar) = $event)),
          "md-position": "center",
          "md-duration": 2000,
          "md-persistent": true
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", null, _toDisplayString(_ctx.state.snackMessage), 1)
          ], undefined, true),
          _: 1
        }, 8, ["md-active"]),
        (_ctx.state.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_component_md_progress_spinner, {
                "md-mode": "indeterminate",
                "md-stroke": 2
              })
            ]))
          : _createCommentVNode("", true)
      ], undefined, true),
      _: 1
    }),
    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "background" }, null, -1))
  ]))
}